<template>
  <div v-if="article">
    <ArticleFull :article="article" />
  </div>
  <div v-else class="article-not-found">
    <div class="container">
      <h2>Article non trouvé</h2>
      <router-link to="/" class="back-to-home">
        <i class="fas fa-arrow-left"></i> Retour à l'accueil
      </router-link>
    </div>
  </div>
</template>

<script>
import ArticleFull from '../components/ArticleFull.vue'
import { articles } from '../data/articles'

export default {
  name: 'ArticleView',
  components: {
    ArticleFull
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    article() {
      return articles.find(a => a.id == this.id)
    }
  }
}
</script>

<style scoped>
.article-not-found {
  padding: 100px 0;
  text-align: center;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.article-not-found h2 {
  font-size: 2rem;
  margin-bottom: 30px;
  color: var(--dark);
}

.back-to-home {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--primary);
  color: white;
  padding: 12px 24px;
  border-radius: var(--radius);
  text-decoration: none;
  font-weight: 600;
  transition: var(--transition);
}

.back-to-home:hover {
  background: var(--primary-dark);
  transform: translateX(-5px);
}
</style>